export default __webpack_public_path__ + "static/media/port_cv.6b71245a.svg";